export const getPrintTemplate = (values) => {
  const {
    unit = "",
    address = "",
    reportMonth = "",
    reportYear = "",
    productName = "",
    itemsHeader = [],
    rows = [],
    ledgerClerk = "",
    chiefAccountant = "",
    legalRepresentative = "",
    signingDay = "",
    signingMonth = "",
    signingYear = "",
  } = values;

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "0");

  let headersHtml = "";
  itemsHeader.forEach((header) => {
    headersHtml += `<th class="border" width="100">${header}</th>`;
  });

  let indexHeadersHtml = "";
  itemsHeader.forEach((_, idx) => {
     indexHeadersHtml += `<th class="border">${idx + 2}</th>`;
  });

  let rowsHtml = "";
  rows.forEach((row) => {
    let itemsHtml = "";
    (row.itemAmounts || []).forEach((val) => {
      itemsHtml += `<td class="border text-right px-1">${fmt(val)}</td>`;
    });

    rowsHtml += `
      <tr>
        <td class="border px-1">${row.criteria || ""}</td>
        <td class="border text-right px-1 font-bold">${fmt(row.totalAmount)}</td>
        ${itemsHtml}
      </tr>
    `;
  });

  return `
    <div style="font-family: 'Times New Roman', Times, serif; font-size: 13px; color: black; line-height: 1.4;">
      <table width="100%">
        <tr>
          <td width="60%" valign="top">
            <div class="font-bold">Đơn vị: <span style="font-weight: normal; border-bottom: 1px dotted black;">${unit}</span></div>
            <div class="font-bold">Địa chỉ: <span style="font-weight: normal; border-bottom: 1px dotted black;">${address}</span></div>
          </td>
          <td width="40%" align="center">
            <div class="font-bold">Mẫu số S37-DN</div>
            <div style="font-style: italic; font-size: 11px;">(Kèm theo Thông tư số 99/2025/TT-BTC <br/> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
          </td>
        </tr>
      </table>

      <div style="text-align: center; margin: 20px 0;">
        <h2 style="margin: 0; text-transform: uppercase;">THẺ TÍNH GIÁ THÀNH SẢN PHẨM, DỊCH VỤ</h2>
        <div style="margin-top: 10px;">Tháng ${reportMonth} năm ${reportYear}</div>
        <div style="margin-top: 10px;">Tên sản phẩm, dịch vụ: <span style="font-weight: bold; border-bottom: 1px dotted black;">${productName}</span></div>
      </div>

      <table width="100%" style="border-collapse: collapse; margin-top: 20px;">
        <thead>
          <tr>
            <th class="border" rowspan="2">Chỉ tiêu</th>
            <th class="border" rowspan="2" width="120">Tổng số tiền</th>
            <th class="border" colspan="${itemsHeader.length}">Chia ra theo khoản mục</th>
          </tr>
          <tr>
            ${headersHtml}
          </tr>
          <tr bgcolor="#F0F0F0">
            <th class="border">A</th>
            <th class="border">1</th>
            ${indexHeadersHtml}
          </tr>
        </thead>
        <tbody>
          ${rowsHtml}
        </tbody>
      </table>

      <table width="100%" style="margin-top: 40px; text-align: center;">
        <tr>
          <td width="30%">
            <div class="font-bold">Người ghi sổ</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên)</div>
            <div style="margin-top: 80px;" class="font-bold">${ledgerClerk}</div>
          </td>
          <td width="30%">
            <div class="font-bold">Kế toán trưởng</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên)</div>
            <div style="margin-top: 80px;" class="font-bold">${chiefAccountant}</div>
          </td>
          <td width="40%">
            <div style="font-style: italic; font-size: 11px; margin-bottom: 5px;">Ngày ${signingDay} tháng ${signingMonth} năm ${signingYear}</div>
            <div class="font-bold">Người đại diện theo pháp luật</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên, đóng dấu)</div>
            <div style="margin-top: 80px;" class="font-bold">${legalRepresentative}</div>
          </td>
        </tr>
      </table>
    </div>

    <style>
      .border { border: 1px solid black; }
      .text-center { text-align: center; }
      .text-right { text-align: right; }
      .font-bold { font-weight: bold; }
      .px-1 { padding: 0 4px; }
    </style>
  `;
};
